import { useState } from "react";
import classNames from "classnames";
import config from "config";
import { ReactComponent as Logo } from "imgs/ViaductLogoBlack.svg";
import { useTranslation } from "react-i18next";
import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

interface Props {
  expanded: boolean;
  toggleExpand: () => void;
}

interface ViaductLogoProps {
  className?: string;
}

const ViaductLogo = ({ className }: ViaductLogoProps) => {
  const { t } = useTranslation("common");

  return (
    <Logo
      className={classNames("w-[100px] h-auto", className)}
      title={t("logo_title")}
    />
  );
};

const ViaductLogoSection = ({ expanded, toggleExpand }: Props) => {
  const [hovered, setHovered] = useState(false);

  const onMouseEnter = () => setHovered(true);
  const onMouseLeave = () => setHovered(false);

  return (
    <div
      className={classNames(
        "tracking-normal focus:outline-hidden flex flex-row gap-4 items-center cursor-pointer h-[60px]",
        {
          "justify-center": !expanded,
          "px-4 border-t-8 border-t-[#FF6161] border-b border-b-gray-100":
            expanded,
          "bg-gray-700": !expanded && !config.isInstanceManagement(),
          "bg-slate-100": expanded && !config.isInstanceManagement() && hovered,
        }
      )}
      key="logo"
      onClick={() => {
        toggleExpand();
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {expanded && (
        <div className="cursor-pointer tracking-normal px-2 py-0.5">
          <div className="flex items-center space-x-7.5">
            <KeyboardDoubleArrowLeftOutlinedIcon
              className={classNames("text-gray-300", {
                "text-gray-700": hovered,
              })}
            />
            <ViaductLogo />
          </div>
        </div>
      )}
      {!expanded && (
        <MenuOutlinedIcon
          className={classNames("", {
            "text-black": config.isInstanceManagement(),
            "text-gray-400": !config.isInstanceManagement() && !hovered,
            "text-white": !config.isInstanceManagement() && hovered,
          })}
        />
      )}
    </div>
  );
};

export default ViaductLogoSection;
